import { BiteLogVerifonePointScaEvent } from './bite_log_verifone_point_sca_event.js';

export function name(event: BiteLogVerifonePointScaEvent): string {
  switch (event) {
    case BiteLogVerifonePointScaEvent.None:
      return 'ok';
    case BiteLogVerifonePointScaEvent.Success:
      return 'success';
    case BiteLogVerifonePointScaEvent.TerminalRestarted:
      return 'terminal-restarted';
    case BiteLogVerifonePointScaEvent.SaleTransaction:
      return 'sale-transaction';
    case BiteLogVerifonePointScaEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogVerifonePointScaEvent.AuthenticationError:
      return 'authentication-error';
    case BiteLogVerifonePointScaEvent.PortError:
      return 'port-error';
    case BiteLogVerifonePointScaEvent.SyncTimeError:
      return 'sync-time-error';
    case BiteLogVerifonePointScaEvent.KeyStoreError:
      return 'key-store-error';
    case BiteLogVerifonePointScaEvent.TerminalDisconnected:
      return 'terminal-disconnected';
    case BiteLogVerifonePointScaEvent.CaptureTimeoutRecovery:
      return 'capture-timeout-recovery';
    case BiteLogVerifonePointScaEvent.CaptureTimeoutGatewayStuck:
      return 'capture-timeout-gateway-stuck';
    case BiteLogVerifonePointScaEvent.CaptureTimeoutSessionCleanupFailed:
      return 'capture-timeout-session-cleanup-failed';
    case BiteLogVerifonePointScaEvent.CaptureTimeoutPaymentRecovered:
      return 'capture-timeout-payment-recovered';
    case BiteLogVerifonePointScaEvent.StartSessionBusyRecovery:
      return 'start-session-busy-recovery';
  }
}
